import axios from "axios";
import { ENV } from "../../env";

export const DAS_API_URL = `https://www.${
  ENV !== "production" ? (ENV === "development" ? "dev" : ENV) + "-" : ""
}manage-mii.uk/api/das`;

const getSportsData = async ({ sportId, leagueId, leagueIds, courts }) => {
  const params = new URLSearchParams();
  const resolvedLeagueIds = leagueIds ?? leagueId;

  if (Array.isArray(resolvedLeagueIds)) {
    const ids = resolvedLeagueIds.map(String).filter(Boolean);
    if (ids.length > 0) {
      params.set("leagueIds", ids.join(","));
    }
  } else if (resolvedLeagueIds != null && resolvedLeagueIds !== "") {
    params.set("leagueId", String(resolvedLeagueIds));
  }

  if (courts != null) {
    const courtsBase64 = btoa(
      unescape(encodeURIComponent(JSON.stringify(courts)))
    );
    params.set("courts", courtsBase64);
  }

  const query = params.toString();
  const response = await axios.get(
    `${DAS_API_URL}/sports/${sportId}/results${query ? `?${query}` : ""}`
  );
  return response.data;
};

const sportsService = {
  getSportsData
};

export default sportsService;
